import { render, staticRenderFns } from "./RentalPeriodCart.vue?vue&type=template&id=5f707f81&"
import script from "./RentalPeriodCart.vue?vue&type=script&lang=js&"
export * from "./RentalPeriodCart.vue?vue&type=script&lang=js&"
import style0 from "./RentalPeriodCart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.west-vlaanderen/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BForm} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BForm})
    

export default component.exports